/**
 * features.js — modes that exist in the code but are switched off in a build.
 */

/**
 * Is Local Multiplayer offered on the menu?
 *
 * Two fighters on one machine, player 2 on a controller. Off for now: the web
 * game is played one person per device, and the mode comes back with the
 * console ports (PlayStation, Xbox), where a second pad is the normal way to
 * play. Only the menu entry is gated — the mode itself, its controller
 * mapping and its tests all stay built, so turning it back on is this switch
 * and nothing else.
 *
 * On when built with REACT_APP_LOCAL_MULTIPLAYER=1 (what a console build will
 * set), or for a single page load with `?local` in the URL — how the e2e
 * suite reaches it, and a way to try it on the live site.
 *
 * @param {string} [search] location.search; defaults to the current page's.
 * @returns {boolean}
 */
export function localMultiplayerEnabled(
  search = typeof window !== 'undefined' ? window.location.search : ''
) {
  return process.env.REACT_APP_LOCAL_MULTIPLAYER === '1'
    || new URLSearchParams(search).has('local');
}
